import {FC} from "react";
import type {DecisionSupportContext} from "./decisionSupport";

interface DecisionSupportContextPanelProps {
    context: DecisionSupportContext;
}

export const DecisionSupportContextPanel: FC<DecisionSupportContextPanelProps> = ({
    context
}) => (
    <div className="pi-decision-context">
        <div className="pi-decision-context__row">
            <span className="pi-decision-context__label">Insight</span>
            <p className="pi-decision-context__text">{context.insight}</p>
        </div>
        <div className="pi-decision-context__row">
            <span className="pi-decision-context__label">Action</span>
            <p className="pi-decision-context__text">{context.action}</p>
        </div>
        <div className="pi-decision-context__row">
            <span className="pi-decision-context__label">Goal</span>
            <p className="pi-decision-context__text">{context.goal}</p>
        </div>
    </div>
);

export default DecisionSupportContextPanel;
